import { Particle, type ParticleOptions } from "../Particle";
import { MovesDown } from "../behaviors/MovesDown";
import { PhaseChange } from "../behaviors/PhaseChange";
import { TemperatureNormalization } from "../behaviors/TemperatureNormalization";
import { Fire } from "./Fire";
import { adjustColor } from "../../utils/color";

export class Sawdust extends Particle {
    static colors = [
        0xE3BC9A, // Very Light
        0xC4A484, // Light Brown (Original)
        0xD2B48C, // Tan
        0xA67B5B, // Medium Brown
        0x8B5A2B, // Dark Brown
    ];

    constructor(options: Partial<ParticleOptions> = {}) {
        const baseColor = Sawdust.colors[Math.floor(Math.random() * Sawdust.colors.length)] ?? 0xC4A484;
        super({
            name: "Sawdust",
            color: adjustColor(baseColor, 5), // 稍微调整一点亮度，增加更多微小变化
            behaviors: [
                new MovesDown(), // 粉末状，受重力影响
                new TemperatureNormalization(20, 0.1),
                // 易燃：锯末比木头更容易燃烧，燃点稍微降低一点或保持一致
                new PhaseChange([
                    {
                        temp: 250, // 稍微低一点的燃点
                        type: 'above',
                        factory: () => new Fire()
                    }
                ])
            ],
            props: { 
                isPowder: true, 
                isFlammable: true, 
                isMixable: true,
                thermalConductivity: 0.1 // 导热性一般
            }, 
            temperature: 20,
            minTemp: -273,
            maxTemp: 1000,
            ...options
        });
    }
}
